import { useEffect, useRef } from "react";

/**
 * "−5 rude · Undo" for a few seconds after a tap. Render it with a `key` per tap so a new
 * tap restarts the clock. Today's list can still delete the tap later; this is the quick path.
 */
export function UndoToast({
  text,
  onUndo,
  onDone,
  ms = 10_000,
}: {
  text: string;
  onUndo: () => void;
  onDone: () => void;
  ms?: number;
}) {
  // Held in a ref so a parent re-render does not restart the countdown.
  const done = useRef(onDone);
  done.current = onDone;

  useEffect(() => {
    const t = window.setTimeout(() => done.current(), ms);
    return () => window.clearTimeout(t);
  }, [ms]);

  return (
    <div className="toast" role="status">
      <span className="toast__text">{text}</span>
      <button className="toast__action" type="button" onClick={onUndo}>
        Undo
      </button>
    </div>
  );
}
